import React from 'react';
import { Plus, Upload, Zap, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

const DashboardHeader = ({ onAddListing, onBulkUpload, onQuickList, onBack }) => {
  const { t } = useLanguage();

  return (
    <header className="sticky top-0 z-40" style={{
      background: 'rgba(5, 10, 20, 0.95)',
      backdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(0, 212, 255, 0.15)'
    }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 gap-4">
          <div className="flex items-center gap-3">
            <button
              onClick={onBack}
              className="flex items-center gap-1 text-sm transition-colors"
              style={{ color: '#4A7A9B' }}
              onMouseEnter={e => e.currentTarget.style.color = '#00D4FF'}
              onMouseLeave={e => e.currentTarget.style.color = '#4A7A9B'}
            >
              <ArrowLeft size={16} />
              <span className="hidden sm:inline">{t('back')}</span>
            </button>
            <div className="w-px h-5" style={{ background: 'rgba(0,212,255,0.2)' }} />
            <div className="flex items-center gap-2">
              <img
                src="/assets/images/logo_LL-1772022913346.jpeg"
                alt="ListingLens"
                className="w-8 h-8 rounded-lg object-cover"
                style={{ border: '1px solid rgba(0,212,255,0.3)' }}
              />
              <div>
                <div className="text-sm font-bold" style={{ color: '#E8F4FD' }}>{t('agentDashboardTitle')}</div>
                <div className="text-xs" style={{ color: '#4A7A9B' }}>{t('manageListings')}</div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={onQuickList}
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition-all"
              style={{ background: 'rgba(0, 212, 255, 0.1)', color: '#00D4FF', border: '1px solid rgba(0, 212, 255, 0.25)' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,212,255,0.2)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,212,255,0.1)'}
            >
              <Zap size={14} />
              <span className="hidden sm:inline">{t('quickList')}</span>
            </button>
            <button
              onClick={onBulkUpload}
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition-all"
              style={{ background: 'rgba(123, 47, 255, 0.1)', color: '#7B2FFF', border: '1px solid rgba(123, 47, 255, 0.25)' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(123,47,255,0.2)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(123,47,255,0.1)'}
            >
              <Upload size={14} />
              <span className="hidden sm:inline">{t('bulkUpload')}</span>
            </button>
            <button
              onClick={onAddListing}
              className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-semibold transition-all"
              style={{ background: 'linear-gradient(135deg, #00D4FF, #7B2FFF)', color: '#fff', boxShadow: '0 0 15px rgba(0,212,255,0.25)' }}
            >
              <Plus size={14} />
              <span>{t('addListing')}</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
